import { procurementAPI } from "../../axios";

export const actions = {

    //RfqBacSetting
    GetPendingBAC(context, data){
        return procurementAPI.get(`RfqBacSetting/My/Pending`);
    },
    GetApprovedBAC(context, data){
        return procurementAPI.get(`RfqBacSetting/My/Approved`);
    },
    ApproveBAC(context, data){
        return procurementAPI.post(`RfqBacSetting/Approve/${data}`);
    },
    ChangeBACMember(context, data){
        return procurementAPI.post(`RfqBacSetting/Change/${data.id}`, data);
    },
    GetRfqBacSetting(context, data){
        return procurementAPI.get(`RfqBacSetting/Rfq/${data}`);
    },
    AddBACMember(context, data){
        return procurementAPI.post(`RfqBacSetting/Add`, data);
    },
    DeleteBACMember(context, data){
        return procurementAPI.delete(`RfqBacSetting/Remove/${data}`);
    },
    UpdateBACMember(context, data){
        return procurementAPI.put(`RfqBacSetting/Update/${data.id}`, data);
    }
}